import { render, staticRenderFns } from "./Softwares.vue?vue&type=template&id=57aff830&"
import script from "./Softwares.vue?vue&type=script&lang=js&"
export * from "./Softwares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports